import React, { useState } from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupPurchaseOrderModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";

import {
  MassPurchaseOrderMainteananceBean,
  PageListBean,
  PurchaseOrderSearchCriteria,
  RestPageListBean,
  RestReadRequest,
  RestVendorListRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { VendorService } from "../services/VendorService.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class MassCancelPurchaseOrder extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Mass PurchaseOrders Maintenance",
      isShowExecuteButton: true,
      isShowResetButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new PurchaseOrderSearchCriteria(),
      massPOBean: new MassPurchaseOrderMainteananceBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      inquiryData: null,
      colorLookupHandler: null,
      isShowColorLookup: false,
      isShowPurchaseDateEntry: false,
      isActive: false,
      selectedDataList: [],
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: true,
      isDisableFields: false,
      isNoData: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    ModuleUtils.getPurchaseOrderStatusList();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  componentDidUpdate() {}
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let criteria = this.state.criteria;
      criteria.vendorCode = "";
      criteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        criteria.vendorName = vendorData.description;
        criteria.vendorCode = vendorData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack
    );
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack
    );
  }
  readByVendorCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.vendorPageList != null &&
      response.data.vendorPageList.vendors != null
    ) {
      let vendorCodeData = response.data.vendorPageList.vendors;
      let simpleAutoCompleteList = new Array();
      if (vendorCodeData.length > 0 && vendorCodeData != null) {
        vendorCodeData.map((vendorCode) => {
          let simpleItemBean = {
            code: vendorCode.code,
            description: vendorCode.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        vendorPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };

  loadPage = (pageNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.loadMassPurchaseOrderList(criteria);
  };
  loadMassPurchaseOrderList = (listRequest) => {
    if (SecurityAccessManager.MassCancelPurchaseOrder_IsAccessible()) {
      PurchaseOrderService.getOpenPurchaseOrderLinesForMassMaintenance(
        listRequest,
        this.loadMassPurchaseOrderPageResponse,
        this.loadMassPurchaseOrderPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadMassPurchaseOrderPageResponse = (response) => {
    let inquiryDataList = response.data.massPurchaseOrderBean;
    if (inquiryDataList != null) {
      let dataList = this.toMassOrderMaintenance(inquiryDataList);
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: dataList,
        isNoData: false,
      });
      this.disable();
    } else {
      this.setState({
        isInquiryDatasFound: false,
        isShowResetButton: true,
        isNoData: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadMassPurchaseOrderPageError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  toMassOrderMaintenance = (poBean) => {
    let lineNumber = 1;
    let dataList = [];
    poBean.map((massPoBean) => {
      let massBean = new MassPurchaseOrderMainteananceBean();
      massBean.displayLineNumber = lineNumber;
      massBean.companyCode = massPoBean.companyCode;
      massBean.customerCode = massPoBean.customerCode;
      massBean.customerName = massPoBean.customerName;
      massBean.vendorCode = massPoBean.vendorCode;
      massBean.vendorName = massPoBean.vendorName;
      massBean.fabricStyleCode = massPoBean.fabricStyleCode;
      massBean.fabricStyleName = massPoBean.fabricStyleName;
      massBean.colorCode = massPoBean.colorCode;
      massBean.purchaseOrderNumber = massPoBean.purchaseOrderNumber;
      massBean.purchaseOrderLineNumber = massPoBean.purchaseOrderLineNumber;
      massBean.purchaseOrderStartDate = massPoBean.purchaseOrderStartDate;
      massBean.purchaseOrderStopDate = massPoBean.purchaseOrderStopDate;
      massBean.status = massPoBean.status;
      massBean.amount = massPoBean.amount;
      dataList.push(massBean);
      ++lineNumber;
    });

    return dataList;
  };
  execute = () => {
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new PurchaseOrderSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    this.setState({ criteria: tempCriteria });
  };
  reset = () => {
    let tempCriteria = new PurchaseOrderSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleColorCode = "";
    this.setState({
      criteria: tempCriteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      error_list: [],
      isDisableFields: false,
      isNoData: false,
    });
  };

  viewLineNumber = (val, rowData) => {
    this.setState({ inquiryData: rowData, isShowPurchaseDateEntry: true });
  };

  cancelPOLine = () => {
    let criteria = this.state.criteria;
    if (!isEmptyArray(criteria.purchaseOrderNumbers)) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Cancelling PO ine ..",
      });
      if (SecurityAccessManager.MassCancelPurchaseOrder_IsAccessible()) {
        PurchaseOrderService.cancelMassPurchaseOrder(
          criteria,
          this.cancelMassPurchaseOrderPageResponse,
          this.cancelMassPurchaseOrderPageError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      let errMsg = "Select the Line";
      let error_list = [];
      error_list.push(errMsg);
      this.setState({
        alertMessage: error_list,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelMassPurchaseOrderPageResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    this.handleResponse(response.data);
    this.setState({ isActive: false });
    let criteria = this.state.criteria;
    this.loadMassPurchaseOrderList(criteria);
  };
  cancelMassPurchaseOrderPageError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("error :", error);
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  viewPOModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderModule: true,
        moduleForPopup: (
          <PopupPurchaseOrderModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowVendorModule: true,
        moduleForPopup: (
          <PopupVendorModule
            vendorCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseOrderModule: isOpen,
      isShowVendorModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowPurchaseDateEntry: isShowPopup,
      isShowAlert: isShowPopup,
      error_list: [],
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  checkLine = (e, rowData) => {
    let selectedLine = [];
    rowData.isActive = e.target.value;
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      criteria.companyCode = this.companyCode;
      criteria.purchaseOrderNumbers.push(rowData.purchaseOrderNumber);
      this.setState({ selectedDataList: selectedLine, criteria: criteria });
    } else {
      let rollList = [];
      for (let roll of inquiryDataList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          let tempCriteria = new PurchaseOrderSearchCriteria();
          tempCriteria.companyCode = this.companyCode;
          tempCriteria.vendorCode = criteria.vendorCode;
          tempCriteria.vendorName = criteria.vendorName;
          tempCriteria.purchaseOrderNumbers.push(roll.purchaseOrderNumber);
          this.setState({ selectedDataList: rollList, criteria: tempCriteria });
        }
      }
    }
  };
  selectAllList = () => {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (inquiryDataList != null) {
      inquiryDataList.map((line, i) => {
        line.isActive = true;
        criteria.purchaseOrderNumbers.push(line.purchaseOrderNumber);
      });
      this.setState({ inquiryDataList: inquiryDataList, criteria: criteria });
    }
  };
  unSelectAllList = () => {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = new PurchaseOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    if (inquiryDataList != null) {
      inquiryDataList.map((line, i) => {
        line.isActive = false;
      });
      this.setState({ selectedList: [], criteria: criteria });
    }
  };
  getCaption = (status) => {
    return ModuleUtils.getPurchaseOrderStatusCaption(status);
  };
  poLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, null, this.checkLine, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PurchaseNumber#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewPOModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true, this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StartDate", "purchaseOrderStartDate", true, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "purchaseOrderStopDate", true, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );

    return columns;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isActive", 0, false, null, false, null)
        .setEditableDetails(false, "", null, false, null, true, this.checkLine)
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PurchaseNumber",
        "purchaseOrderNumber",
        0,
        true,
        this.viewPOModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Vendor#",
        "vendorCode",
        0,
        true,
        this.viewVendorModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("VendorName", "vendorName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Status",
        "status",
        0,
        false,
        null,
        false,
        null,
        "8em",
        "15%",
        true,
        ModuleUtils.getPurchaseOrderStatusCaption
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "StartDate",
        "purchaseOrderStartDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "StopDate",
        "purchaseOrderStopDate"
      )
    );

    return columnList;
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    let inquiryData = this.state.inquiryData;
    let isActive = this.state.isActive;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />

        <BaseInquiryToolBar
          isShowExitButton={this.state.isShowExitButton}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.moduleExit}
          execute={this.execute}
          reset={this.reset}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          vendorLookupHandler={this.state.vendorLookupHandler}
          resetInquiry={this.resetInquiry}
          vendorCodeOnChange={this.vendorCodeOnChange}
          cancelPOLine={this.cancelPOLine}
          selectAllList={this.selectAllList}
          unSelectAllList={this.unSelectAllList}
          vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
          displayAutoCompleteVendorList={this.displayAutoCompleteVendorList}
        />
        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            {/* <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={inquiryDataList}
            /> */}
            <CustomTable
              columns={this.poLineColumns()}
              data={inquiryDataList}
              label={"Purchase Lines"}
            />
          </div>
        )}
        {this.state.isNoData && <div className="no_Data">{"NO DATA"}</div>}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const vendorCodeOnChange = (e) => props.vendorCodeOnChange(e);
  const cancelPOLine = (e) => {
    if (e.detail <= 1) {
      handleButton();
      props.cancelPOLine();
    }
  };
  const selectAllList = (e) => {
    if (e.detail <= 1) {
      handleButton();
      props.selectAllList();
    }
  };
  const unSelectAllList = (e) => {
    if (e.detail <= 1) {
      handleButton();
      props.unSelectAllList();
    }
  };
  const vendorCodeEnterKeyEventHandler = (e) => {
    props.vendorCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteVendorList = () => {
    props.displayAutoCompleteVendorList();
  };
  let criteria = props.criteria;
  let vendorLookupHandler = props.vendorLookupHandler;
  let vendorCodeRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Vendor</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={vendorCodeRef}
            name="vendorCode"
            onChange={vendorCodeOnChange}
            value={criteria.vendorCode}
            lookupRequired={true}
            lookupHandler={vendorLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={vendorCodeEnterKeyEventHandler}
            autoCompleteListData={props.vendorPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteVendorList}
            showAutoCompleteList={props.showAutoCompleteVendorList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="vendorName"
            onChange={onChange}
            value={criteria.vendorName}
            disabled={true}
          />
        </Col>
      </Row>
      {props.isInquiryDatasFound && (
        <Row>
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              onClick={(e) => selectAllList(e)}
            >
              SelectAll
            </Button>
          </Col>

          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              onClick={(e) => unSelectAllList(e)}
            >
              UnSelectAll
            </Button>
          </Col>
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              onClick={(e) => cancelPOLine(e)}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      )}
    </div>
  );
}
function MassCancelPurchaseModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <MassCancelPurchaseOrder {...props} name="" /> <br />
    </div>
  );
}

export default MassCancelPurchaseModule;
